import * as ProfileControls from './components/ProfileControls.css';
export default {
    ProfileControls
};
